<template>
	<div>
		<h5>OperationManagement</h5>
	</div>
</template>

<script>
	export default {
		name: "Operation",
	};
</script>

<style scoped></style>
